module.exports = __webpack_public_path__ + "img/opet-infographic-09.4823f7c3.jpg";